module.exports = __webpack_public_path__ + "img/hotpot-design.74feb88a.png";